import { Button } from "../../../Button";
import { ModalContent } from "../../../ModalContent";
import { useRecentLeadsTranslatedContent } from "../../OverviewTables/RecentLeadsTable/useRecentLeadsTranslatedContent";
import { RecentLeadStatusDisplayContent } from "../RecentLeadStatusContent";

type RecentLeadStatusModalProps = {
  isVisible: boolean;
  close: () => void;
  status: string;
};

export const RecentLeadStatusModal = ({
  isVisible,
  close,
  status,
}: RecentLeadStatusModalProps) => {
  const translatedContent = useRecentLeadsTranslatedContent();

  return (
    <ModalContent
      isVisible={isVisible}
      close={close}
      containerClassName="!p-0 flex flex-1 flex-col items-stretch justify-start"
    >
      <div className="mt-2 flex flex-1 flex-col items-stretch justify-start gap-6">
        <RecentLeadStatusDisplayContent status={status} />
        <Button
          data-testid="ok-button"
          onClick={close}
          className="!rounded-lg !bg-surface-brand-default"
        >
          {translatedContent.confirm}
        </Button>
      </div>
    </ModalContent>
  );
};
